import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const ChatHistory = ({ className = "" }) => {
  const navigate = useNavigate();

  const onTiMnHnhClick = useCallback(() => {
    navigate("/41-history-calendar");
  }, [navigate]);

  const onGroupIconClick = useCallback(() => {
    navigate("/41-history-calendar");
  }, [navigate]);

  return (
    <section
      className={`self-stretch flex flex-row items-start justify-start pt-0 px-10 pb-1.5 box-border max-w-full text-left text-5xl text-dark-text font-text-regular-lowercase ${className}`}
    >
      <div className="flex-1 flex flex-col items-start justify-start gap-[39px] max-w-full mq400:gap-[19px]">
        <div className="relative font-semibold">Xem lại lịch sử trò chuyện</div>
        <div className="self-stretch flex flex-row items-start justify-start py-0 pl-0.5 pr-0 box-border max-w-full text-lg">
          <div className="flex-1 flex flex-row items-start justify-start flex-wrap content-start gap-[37px] max-w-full mq360:gap-[18px]">
            <div className="flex flex-col items-start justify-start pt-1.5 px-0 pb-0">
              <div className="flex flex-col items-start justify-start gap-[54px]">
                <div className="w-3 h-3 relative rounded-[50%] bg-light-pink z-[1]" />
                <div className="w-3 h-3 relative rounded-[50%] bg-light-pink z-[1]" />
                <div className="w-3 h-3 relative rounded-[50%] bg-light-pink z-[1]" />
                <div className="w-3 h-3 relative rounded-[50%] bg-light-pink z-[1]" />
              </div>
            </div>
            <div className="h-[242px] flex-1 relative min-w-[201px]">
              <div
                className="absolute top-[0px] left-[0px] leading-[120%] inline-block w-full h-full cursor-pointer"
                onClick={onTiMnHnhClick}
              >
                <p className="m-0">
                  Tại màn hình chính, chọn Xem lịch sử trò chuyện
                </p>
                <p className="m-0">&nbsp;</p>
                <p className="m-0">Mặc định cuộc trò chuyện sẽ là hôm nay</p>
                <p className="m-0">&nbsp;</p>
                <p className="m-0">Vuốt qua phải để xem ngày trước đó</p>
                <p className="m-0">&nbsp;</p>
                <p className="m-0">Muốn xem theo tháng bấm</p>
                <p className="m-0">vào biểu tượng cuốn lịch</p>
              </div>
              <img
                className="absolute top-[202px] left-[251px] w-10 h-10 cursor-pointer z-[1]"
                loading="lazy"
                alt=""
                src="/group-23.svg"
                onClick={onGroupIconClick}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

ChatHistory.propTypes = {
  className: PropTypes.string,
};

export default ChatHistory;
